import { ActionMenuButtonEllipsis } from 'components';
import { Consultation, Document, MenuOption } from 'types';

export const renderDocumentMenuActionButton = (
  consultation: Consultation | undefined,
  options: MenuOption[],
  doc: Document
): JSX.Element => (
  <>
    {consultation && (
      <ActionMenuButtonEllipsis
        data-testid='action-menu-ellipsis'
        consultationId={consultation?.id}
        document={{
          applicationReferenceNumber: consultation.reference,
          documentId: doc.id,
          consultationId: consultation.id,
          fileName: doc.name,
          documentSource: doc.documentSource,
        }}
        options={options}
      />
    )}
  </>
);
